exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-message {\n  display: inline-flex;\n  letter-spacing: 0.01em;\n  font-weight: 500;\n  color: #225cbd;\n  font-size: 13px;\n  margin-top: 4px;\n  cursor: pointer;\n}\n.info-message .label {\n    margin-left: 4px;\n    margin-top: 1px;\n}\n", ""]);

// exports
